export default __webpack_public_path__ + "static/media/assets-film_02.5d1f74a1.jpg";